import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedAdminEmployeesIndexController extends Controller {
  @tracked search = '';
  @tracked page = 1;
  @tracked limit = 25;
  @tracked loading = false;
  // Facet selections (csv). Values within a group OR; groups AND. Every group
  // resolves against this company's `employees_nested` entry — see
  // tio-employee/utils/people-facets.
  // status: 'active' | 'inactive'
  @tracked status = '';
  // enrollment: 'activeEnrolled' | 'everEnrolled' | 'neverEnrolled'
  @tracked enrollment = '';
  // participationStatus: 'participating' | 'pending' | 'deactivated'
  @tracked participationStatus = '';
  @tracked jurisdictions = '';

  // List the actual tracked property names so each binds to a matching URL key
  // (camelCase, like the pslf forms controller's `formType`).
  queryParams = [
    'search',
    'participationStatus',
    'status',
    'enrollment',
    'jurisdictions',
    'page',
    'limit',
  ];
}
